// extracted by mini-css-extract-plugin
export default {"StatusIndicator":"StatusIndicator_RILxE"};